import dynamic from 'next/dynamic'
import { createContext, useContext, useMemo, useState } from 'react'

const OosNotification = dynamic(() => import('@bluheadless/ui/src/organisms/oos-notification/oos-notification'), {
	ssr: false,
})

const OosNotificationContext = createContext()

const OosNotificationProvider = ({ children }) => {
	const [open, setOpen] = useState(false)
	const [product, setProduct] = useState(null)

	const closeOosNotification = () => {
		setOpen(false)
		setProduct(null)
	}

	const contextValue = useMemo(
		() => [
			{ oosNotificationOpened: open },
			{
				openOosNotification: (product) => {
					setProduct(product)
					setOpen(true)
				},
				closeOosNotification,
			},
		],
		[open]
	)

	return (
		<OosNotificationContext.Provider value={contextValue}>
			{children}
			{product && (
				<OosNotification
					onClose={closeOosNotification}
					open={open}
					productId={product.productId}
					productSku={product.productSku}
					title1={product.title1}
					title2={product.title2}
					image={product.image}
					priceProps={product.priceProps}
					attributes={product.attributes}
				/>
			)}
		</OosNotificationContext.Provider>
	)
}

export default OosNotificationProvider

export const useOosNotificationContext = () => {
	const OosNotificationContextValue = useContext(OosNotificationContext)

	if (!OosNotificationContextValue)
		console.warn(
			`OosNotification context value is missing. Verify that OosNotificationProvider is a parent of the current component.`
		)

	return OosNotificationContextValue
}
